"use client";

import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CompleteProjectKits() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="237887" id="feed-the-crowd" className="bg-background text-foreground relative overflow-hidden min-h-[80vh] flex items-center justify-center py-24 lg:py-32">
      {}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {}
        <div className="absolute -top-16 -left-16 md:top-10 md:left-10 w-64 md:w-96 aspect-square rotate-[-12deg] opacity-80 transition-transform duration-1000 hover:scale-105 hover:rotate-[-8deg]">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648254/img/sultani_catering_tray_karahi.png" alt="Sultani Catering Karahi" className="w-full h-full object-cover rounded-3xl shadow-2xl border-4 border-white/5" />
        </div>

        {}
        <div className="absolute -bottom-24 -right-16 md:bottom-10 md:right-10 w-72 md:w-[28rem] aspect-square rotate-[15deg] opacity-80 transition-transform duration-1000 hover:scale-105 hover:rotate-[10deg]">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648254/img/sultani_catering_spread_overhead.png" alt="Sultani Catering Spread" className="w-full h-full object-cover rounded-full shadow-2xl border-4 border-white/5" />
        </div>

        {}
        <div className="absolute top-1/4 -right-20 md:top-1/3 md:right-1/4 w-48 md:w-72 aspect-square rotate-[25deg] opacity-70 transition-transform duration-1000 hover:scale-105 hover:rotate-[20deg]">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648254/img/sultani_smash_burgers_platter.png" alt="Sultani Smash Burgers Platter" className="w-full h-full object-cover rounded-2xl shadow-2xl border-4 border-white/5" />
        </div>

        {}
        <div className="absolute top-1/3 left-1/4 w-8 h-8 bg-primary/20 rounded-sm rotate-45 blur-sm animate-pulse"></div>
        <div className="absolute bottom-1/3 left-1/3 w-12 h-12 bg-secondary/20 rounded-sm rotate-12 blur-md"></div>
        <div className="absolute top-2/3 right-1/3 w-6 h-6 bg-accent/30 rounded-sm rotate-[-15deg] blur-sm animate-pulse" style={{
        animationDelay: "1s"
      }}></div>

        {}
        <div className="absolute inset-0 bg-background/80 md:bg-background/60 backdrop-blur-[2px]"></div>
      </div>

      {}
      <div ref={contentRef} className={`relative z-10 container mx-auto px-4 text-center flex flex-col items-center transition-all duration-1000 transform ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-secondary/20 border border-secondary/30 backdrop-blur-md mb-8 shadow-lg">
          <Sparkles className="w-4 h-4 text-primary" />
          <span className="text-sm font-medium tracking-widest text-white uppercase font-default">
            Premium Halal Catering
          </span>
        </div>

        <h2 className="text-5xl md:text-7xl lg:text-8xl font-bold font-serif tracking-wider mb-6 text-white drop-shadow-2xl max-w-4xl uppercase">
          Sultani At Your Event
        </h2>
        
        <p className="text-xl md:text-2xl max-w-2xl mx-auto mb-12 text-white/90 drop-shadow-xl font-default leading-relaxed">
          From corporate gatherings to family celebrations, we bring the bold flavors of Punjabi-American fusion to your table.
        </p>

        {}
        <div className="relative group">
          {}
          <div className="absolute -inset-2 bg-primary rounded-full blur-md opacity-40 group-hover:opacity-60 transition duration-300 animate-pulse"></div>
          
          <Button asChild size="lg" className="relative text-lg h-14 px-8 rounded-full bg-primary hover:bg-primary/90 text-primary-foreground border border-white/10 shadow-2xl transition-transform hover:scale-105 font-default font-bold uppercase tracking-wide">
            <Link to="#">
              Inquire Now
              <ArrowRight className="ml-2 w-5 h-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}